import React, { useEffect } from "react";
import DialogModal from "../../reusables/DialogModal";

const EditCompanyDialog = ({ isOpen, onClose, onSubmit, register, errors, setValue, watch, company }) => {
  const currentPlan = watch("editPlan");

  useEffect(() => {
    if (company?.plan) {
      setValue("editPlan", company.plan);
    }
  }, [company, setValue]);
  return (
    <DialogModal isOpen={isOpen} onClose={onClose} title="Edit Company">
      <form onSubmit={onSubmit} className="grid gap-3 mt-4">
        <input
          placeholder="Company Name"
          {...register("editName", { required: "Company name is required" })}
          className="p-3 rounded-md border text-gray-700"
        />
        {errors.editName && (
          <span className="text-red-500 text-sm">{errors.editName.message}</span>
        )}

        <input
          placeholder="New Admin Email (optional)"
          {...register("editAdminEmail")}
          className="p-3 rounded-md border text-gray-700"
        />

        <input
          placeholder="New Admin Password (optional)"
          type="password"
          {...register("editAdminPassword")}
          className="p-3 rounded-md border text-gray-700"
        />

        <input
          placeholder="Max Users"
          type="number"
          {...register("editMaxUsers", { required: "Number of users is required" })}
          className="p-3 rounded-md border text-gray-700"
        />
        {errors.editMaxUsers && (
          <span className="text-red-500 text-sm">{errors.editMaxUsers.message}</span>
        )}

        <select
          {...register("editPlan", { required: "Plan selection is required" })}
          value={currentPlan}
          className="p-3 rounded-md border text-gray-700"
        >
          <option value="">Select a Plan</option>
          <option value="Basic">Basic</option>
          <option value="Standard">Standard</option>
          <option value="Premium">Premium</option>
        </select>
        {errors.editPlan && (
          <span className="text-red-500 text-sm">{errors.editPlan.message}</span>
        )}

        <div className="mt-4 flex justify-between gap-3">
          <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-300 rounded">
            Cancel
          </button>
          <button type="submit" className="px-4 py-2 bg-customeOrange text-white rounded">
            Save Changes
          </button>
        </div>
      </form>
    </DialogModal>
  );
};

export default EditCompanyDialog;